import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertActionUpdateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertActionUpdateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertActionUpdateInput = {
  ParentActionId: string;
  Title: string;
  Description: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertActionUpdate = createMutationHook({
  name: 'insertActionUpdate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.updates.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertActionUpdateInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.action.updates.getActionUpdatesByParentActionId.queryKey(),
    trpc.frontend.action.updates.getActionUpdateById.queryKey(),
    // COI-889: the Actions register's latest-update and update-count columns
    // read `actionUpdateSummary`.
    trpc.frontend.action.register.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertActionUpdateMutation => ({
    insert_action_update_one: {
      __typename: 'action_update',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertActionUpdateDocument,
  graphqlVariables: (input: InsertActionUpdateInput) => ({ ...input }),
});
